export enum TypeRequest {
    AfiliateTabajador = 0,
    EstadoCivil = 1,
    RemoveBeneficiary = 2,
    RemoveWorker = 3,
    AfiliateBeneficiary = 4,
    Discapacidad = 5,
    ACM = 6,
}